import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import api from '../../../utils/api'
import { toast } from 'react-toastify';
import AdminLayout from '../components/AdminLayout';

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 24px;
  color: #6b7280;
  a { color: #00a6c2; text-decoration: none; &:hover { text-decoration: underline; } }
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 24px 0;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 16px;
`;

const FormSection = styled.div`
  max-width: 600px;
`;

const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  &:focus { outline: none; border-color: #00a6c2; }
`;

const SubmitButton = styled.button`
  margin-top: 16px;
  padding: 12px 24px;
  background: #00a6c2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  &:hover { background: #0094ab; }
  &:disabled { background: #9ca3af; cursor: not-allowed; }
`;

function AdminTalentTrainedPage() {
  const [emails, setEmails] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!emails.trim()) {
      toast.error('Please enter at least one email address');
      return;
    }

    setSubmitting(true);
    try {
      // BE expects emails as comma-separated string, not array
      await api.post('/admin2/users/talent_trained.json', {
        emails: emails
      });
      toast.success('Contributors marked as trained successfully');
      setEmails('');
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Failed to update contributors');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminLayout title="Users" pageTitle="New Trained Contributors">
      <Breadcrumb>
        <Link to="/admin2/users">Users</Link>
        <span>›</span>
        <span>Talent trained</span>
        <span>›</span>
        <span>New</span>
      </Breadcrumb>

      <PageTitle>Input contributors to be marked trained</PageTitle>

      <FormSection>
        <form onSubmit={handleSubmit}>
          <Label>User email addresses - comma seperated</Label>
          <Textarea
            value={emails}
            onChange={(e) => setEmails(e.target.value)}
            placeholder="user1@example.com, user2@example.com"
          />
          <SubmitButton type="submit" disabled={submitting}>
            {submitting ? 'Processing...' : 'Mark contributors as trained'}
          </SubmitButton>
        </form>
      </FormSection>
    </AdminLayout>
  );
}

export default AdminTalentTrainedPage;
